import { Component, OnInit } from '@angular/core';
import {StoreService} from "../../../../shared/services/store.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-extension',
    templateUrl: './extension.component.html',
    styleUrls: ['./extension.component.scss'],
    standalone: false
})
export class ExtensionComponent implements OnInit {

  constructor(
    public storeService: StoreService,
    public translateService: TranslateService
  ) { }

  ngOnInit(): void {
  }

}
